import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import {
  DxiColumnComponent,
  DxiValidationRuleComponent,
  DxoEditingComponent,
  DxoExportComponent,
  DxoFilterRowComponent,
  DxoLookupComponent,
  DxoPagerComponent,
  DxoPagingComponent,
  DxoTextsComponent,
} from 'devextreme-angular/ui/nested';
import CustomStore from 'devextreme/data/custom_store';
import notify from 'devextreme/ui/notify';
import { firstValueFrom } from 'rxjs';
import { GestArticoliBaseComponent } from 'src/app/shared/components/gest-articoli-base/gest-articoli-base.component';
import { RepartiService } from 'src/app/shared/services/reparti.service';
import { SitiService } from 'src/app/shared/services/siti.service';
import { GridExportExcel } from 'src/app/utils/grid-export-excel';

@Component({
  selector: 'app-reparti',
  templateUrl: './reparti.component.html',
  imports: [
    DxDataGridComponent,
    DxiColumnComponent,
    DxiValidationRuleComponent,
    DxoEditingComponent,
    DxoTextsComponent,
    DxoPagingComponent,
    DxoPagerComponent,
    DxoFilterRowComponent,
    DxoLookupComponent,
    DxoExportComponent,
  ],
  standalone: true,
})
export class RepartiComponent
  extends GestArticoliBaseComponent
  implements OnInit
{
  private repartiService = inject(RepartiService);
  private sitiService = inject(SitiService);

  dataSource: any;
  listSiti: any;

  onUpdating(e: any) {
    e.newData = Object.assign(e.oldData, e.newData);
  }

  ngOnInit() {
    this.loadLookups();
    this.loadDataSource();
  }

  loadLookups() {
    this.sitiService.listTemp().subscribe({
      next: (res) => {
        this.listSiti = {
          store: {
            type: 'array',
            data: res,
            key: 'id',
          },
          pageSize: 10,
          paginate: true,
        };
      },
    });
  }

  loadDataSource() {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => {
        return firstValueFrom(this.repartiService.list())
          .then((response) => {
            return {
              data: response,
            };
          })
          .catch(() => {
            throw 'Data loading error';
          });
      },
      insert: (values) => {
        return firstValueFrom(this.repartiService.insert(values))
          .then((res) => {
            this.repartiService.listTemp(true).subscribe();
            return res;
          })
          .catch((error: HttpErrorResponse) => {
            if (error.status == 500) {
              throw error.error.title;
            } else {
              throw 'Insert failed';
            }
          });
      },
      remove: (values) => {
        console.log(values);
        return firstValueFrom(this.repartiService.remove(values))
          .then(() => {
            console.log('delete eseguito');
            this.repartiService.listTemp(true).subscribe();
          })
          .catch((error: HttpErrorResponse) => {
            if (error.status == 500) {
              throw error.error.title;
            } else {
              throw 'Deletion failed';
            }
          });
      },
      update: (key, values) => {
        this.repartiService.listTemp(true).subscribe();
        return firstValueFrom(this.repartiService.update(key, values))
          .then(() => {
            this.repartiService.listTemp(true).subscribe();
          })
          .catch((error: HttpErrorResponse) => {
            if (error.status == 500) {
              throw error.error.title;
            } else {
              throw 'Update failed';
            }
          });
      },
    });
  }

  onExporting(e: any) {
    GridExportExcel(e, 'Reparti', 'Reparti.xlsx');
  }
}
